
<span *ngIf="status" class="badge badge-success">Ativo</span>
<span *ngIf="!status" class="badge badge-secondary">Inativo</span>